// TLA NextActionResolver (arch doc §4.6/D15). Reads GET /api/journeys/me/recommendations
// READ-ONLY via an injected fetcher, maps the top recommendation to a route, and ALWAYS
// resolves (never throws to the UI). D15: every recommendation resolves to plain /journey
// in v1 (LifeJourneyPage does not read query params, so no ?focus= deep-link).
//
// Reusability guardrail: the FlowBar only ever sees a neutral experience.* labelKey.
// The journey.rec.* / message_key vocabulary stays confined to this resolver's meta.
export function createTlaNextActionResolver({ fetcher, resolveDashboardPath }) {
  function dashboardDefault(ctx) {
    const dash = resolveDashboardPath((ctx && ctx.auth) || {});
    return { path: dash.path || '/', labelKey: 'experience.flowbar.dashboard', source: 'default' };
  }

  return {
    async resolve(ctx) {
      try {
        const recs = await fetcher();
        if (Array.isArray(recs) && recs.length > 0) {
          const top = recs[0] || {};
          return {
            path: '/journey',
            labelKey: 'experience.flowbar.next',
            source: 'recommendation',
            meta: { taskId: top.task_id, categoryId: top.category_id, type: top.type },
          };
        }
        return dashboardDefault(ctx);
      } catch (e) {
        return dashboardDefault(ctx);
      }
    },
  };
}
